import firebase from "./firebase.js";

export function signIn(payload) {
	if (firebase.auth().currentUser) {
		return new Promise((resolve, reject) => {
			const currentUser = firebase.auth().currentUser;
			if (currentUser.email === payload.email) {
				resolve({ status: 200, json: () => Promise.resolve(currentUser) });
			} else {
				firebase
					.auth()
					.signOut()
					.then(() => {
						resolve(signIn(payload));
					});
			}
		});
	} else {
		return new Promise((resolve, reject) => {
			const { email, password } = payload;
			if (email.length < 4) {
				alert("Correo invalido.");
				return;
			}
			if (password.length < 4) {
				alert("Introduzca contraseña.");
				return;
			}
			firebase
				.auth()
				.signInWithEmailAndPassword(email, password)
				.then(() => {
					const user = authCredentials();
					if (user !== null) {
						success(user);
					}
					error("Ocurrio un error al intentar acceder a la informacion de usuario");
				})
				.catch((err) => {
					const { code, message } = err;
					if (code === "auth/wrong-password") {
						error("Contraseña incorrecta");
					} else if (code === "auth/user-not-found") {
						error("Usuario no existente");
					} else {
						error(message);
					}
				});

			function success(user) {
				resolve({ status: 200, json: () => Promise.resolve(user) });
			}

			function error(message) {
				resolve({ status: 400, json: () => Promise.resolve(message) });
			}
		});
	}
}

export function signOut() {
	firebase.auth().signOut();
}
export function sendPasswordReset() {
	const email = document.getElementById("email").value;
	firebase
		.auth()
		.sendPasswordResetEmail(email)
		.then(function () {
			alert("Password Reset Email Sent!");
		})
		.catch(function (error) {
			const errorCode = error.code;
			const errorMessage = error.message;
			if (errorCode === "auth/invalid-email") {
				alert(errorMessage);
			} else if (errorCode === "auth/user-not-found") {
				alert(errorMessage);
			}
			console.log(error);
		});
}

export function authListener() {
	return new Promise((resolve, reject) => {
		firebase.auth().onAuthStateChanged((user) => {
			if (user) {
				return resolve({
					name: user.displayName,
					email: user.email,
					photoUrl: user.photoUrl,
					emailVerified: user.emailVerified,
					uid: user.uid,
				});
			} else {
				return resolve(null);
			}
		});
	});
}

export function authCredentials() {
	const user = firebase.auth().currentUser;
	if (user) {
		return {
			name: user.displayName,
			email: user.email,
			photoUrl: user.photoUrl,
			emailVerified: user.emailVerified,
			uid: user.uid,
		};
	}
	return null;
}

export function updateUserProfile({ displayName, photoUrl }) {
	const user = firebase.auth().currentUser;
	user.updateProfile({ displayName, photoUrl });
}

export function updatePassword(newPassword) {
	const user = firebase.auth().currentUser;
	user
		.updatePassword(newPassword)
		.then(() => {
			return "Contraseña actualizada";
		})
		.catch((error) => `Ocurrio un error ${error}`);
}

export function resetPassword(email) {
	const auth = firebase.auth();
	auth
		.sendPasswordResetEmail(email)
		.then(() => "Correo de recuperación enviado")
		.catch((error) => `Ocurrio un error ${error}`);
}
